import { deleteMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const DELETE_SUB_PRACTICE_LIST = 'DELETE_SUB_PRACTICE_LIST';
export const DELETE_SUB_PRACTICE_LIST_SUCCESS =
  'DELETE_SUB_PRACTICE_LIST_SUCCESS';
export const DELETE_SUB_PRACTICE_LIST_FAILURE =
  'DELETE_SUB_PRACTICE_LIST_FAILURE';

// Action Creators
export const deleteSubPracticeList = () => ({
  type: DELETE_SUB_PRACTICE_LIST,
});

export const deleteSubPracticeListSuccess = (users) => ({
  type: DELETE_SUB_PRACTICE_LIST_SUCCESS,
  payload: users,
});

export const deleteSubPracticeListFailure = (error) => ({
  type: DELETE_SUB_PRACTICE_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const deleteSubPracticeData = (external, id) => {
  return async (dispatch) => {
    dispatch(deleteSubPracticeList());
    try {
      const response = await deleteMethodWithToken(
        url?.deleteSubPractice + id + '/'
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(deleteSubPracticeListSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(deleteSubPracticeListFailure('error?.message'));
      }
    } catch (error) {
      dispatch(deleteSubPracticeListFailure(error?.message));
    }
  };
};
